import ClickAwayListener from '@mui/material/ClickAwayListener';
import Grow from '@mui/material/Grow';
import Paper from '@mui/material/Paper';
import Popper from '@mui/material/Popper';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import React from 'react';

function Dropdown({ anchorEl, children, className, handleClose = () => {}, open, placement, style }) {
  return (
    <div className="dropdown">
      <div>
        <Popper anchorEl={anchorEl} className={clsx(className, 'dropdown__lib')} open={open} placement={placement} role={undefined} style={style} transition>
          {({ TransitionProps, placement }) => (
            <Grow {...TransitionProps} style={{ transformOrigin: 'center top' }}>
              <Paper>
                <ClickAwayListener onClickAway={handleClose}>
                  <div>{children}</div>
                </ClickAwayListener>
              </Paper>
            </Grow>
          )}
        </Popper>
      </div>
    </div>
  );
}

Dropdown.propTypes = {
  anchorEl: PropTypes.object,
  open: PropTypes.bool,
  children: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
  handleClose: PropTypes.func,
};

export default Dropdown;
